"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ClickOut = _interopRequireDefault(require("../util/ClickOut"));

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import Message from '../Message';
var Sidebar = function Sidebar(props) {
  var show = props.show,
      _props$navs = props.navs,
      navs = _props$navs === void 0 ? [] : _props$navs,
      onClose = props.onClose;

  var onClickOut = function onClickOut(e) {// if (onClose && show) {
    //
    //   onClose();
    // }
  };

  var _onClose = function _onClose(e) {
    if (onClose) {
      onClose();
    }
  };

  var clickNav = function clickNav(e) {
    //console.log('Sidebar history', history)
    console.log('Sidebar clickNav', e.currentTarget);
    var el = e.currentTarget;
    console.log('Sidebar clickNav', el.dataset.link); //GO TO LINK
  };

  var navRows = navs.map(function (nav, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      className: "nav-item"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "nav-link",
      href: "#",
      "data-link": nav.link,
      onClick: clickNav
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: (0, _clsx.default)('nav-icon', {
        fa: nav.icon
      }, nav.icon ? nav.icon : '')
    }), ' ', nav.titleId));
  });
  return /*#__PURE__*/_react.default.createElement(_ClickOut.default, {
    onClickOut: onClickOut
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('sidebar-cover', {
      'sidebar-cover-hide': !show
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('sidebar', {
      'sidebar-hide': !show
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'sidebar-toolbar',
    onClick: _onClose
  }, "CLOSE"), /*#__PURE__*/_react.default.createElement("div", {
    className: 'sidebar-content'
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: 'sidebar-nav'
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "nav"
  }, navRows)))));
};

var _default = Sidebar;
exports.default = _default;